<template>
    <div>
        <div class="headerbg">
            <b-container>
                <h1>信箱驗證</h1>
            </b-container>
        </div>
        <b-container style="min-height: 43vh;">
            <div class="text-dark">
                請點擊按鈕啟用會員帳號
                <button
                class="btn btn-primary"
                :disabled="loading || !userId"
                @click="activate"
                >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                啟用會員帳號
                </button>

                <b-alert
                variant="success"
                show
                class="mt-3"
                v-if="ok"
                >
                啟用成功！您現在可以登入。
                </b-alert>

                <b-alert
                variant="danger"
                show
                class="mt-3"
                v-if="error"
                >
                {{ error }}
                </b-alert>
            </div>
        </b-container>
    </div>
</template>
<script>
    import { apiActivateMember } from '@/api/API';
    export default {
        name: 'ActivateUser',
        data() {
            return {
                loading: false,
                ok: false,
                error: '',
                token: '',
            };
        },
        computed: {
            userId() {
                return this.token;
            },
        },
        created() {
            this.token = this.$route.query.code || '';
            this.clearTokenFromUrl();
        },
        mounted() {},
        methods: {
            clearTokenFromUrl() {
                if (!this.$route.query.code) {
                    return;
                }

                this.$router.replace({
                    name: this.$route.name,
                    query: {},
                }).catch(() => {});
            },
            async activate() {
                if (!this.userId) { this.error = '缺少驗證碼'; return; }
      this.loading = true; this.error = ''; this.ok = false;
      try {
        await apiActivateMember(this.userId);
        this.ok = true;
      } catch (e) {
        const r = e.response;
        // 400 很可能是：已啟用 / 找不到帳號 / 參數名不符
        this.error = r?.data?.message || r?.data || `啟用失敗（${r?.status || e.message}）`;
      } finally {
        this.loading = false;
      }
            },
        },
    };
</script>
